import React, { useState, useEffect } from "react";
import { Carousel, Modal } from "react-bootstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";





function GAKGallery() {
  const [modalShow, setModalShow] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const [imagesToShow, setImagesToShow] = useState(8);
  const [showLess, setShowLess] = useState(false); 

  const handleCloseModal = () => {
    setModalShow(false);
  };

  const handleOpenModal = (index) => {
    setSelectedImageIndex(index);
    setModalShow(true);
  };

  const handleLoadMore = () => {
    setImagesToShow(imagesToShow + 8);
    if (imagesToShow + 8 >= lowResImages.length) {
      setShowLess(true); // Oculta el botón "Ver Más" cuando se muestran todas las imágenes
    }
  };

  const handleShowLess = () => {
    setImagesToShow(8);
    setShowLess(false);
  };


  const lowResImages = [

 { id: 69, src: "img/GAK-gallery/59.jpg", alt: "get a toy crane machine" },
    { id: 70, src: "img/GAK-gallery/60.jpg", alt: "get a toy crane machine" },
    { id: 71, src: "img/GAK-gallery/61.jpg", alt: "get a toy crane machine" },
    { id: 72, src: "img/GAK-gallery/62.jpg", alt: "get a toy crane machine" },
    { id: 73, src: "img/GAK-gallery/63.jpg", alt: "get a toy crane machine" },
    { id: 74, src: "img/GAK-gallery/64.jpg", alt: "get a toy crane machine" },
    { id: 75, src: "img/GAK-gallery/65.jpg", alt: "get a toy crane machine" },
    { id: 76, src: "img/GAK-gallery/66.jpg", alt: "get a toy crane machine" },
    { id: 77, src: "img/GAK-gallery/67.jpg", alt: "get a toy crane machine" },
    { id: 78, src: "img/GAK-gallery/68.jpg", alt: "get a toy crane machine" },
    { id: 79, src: "img/GAK-gallery/69.jpg", alt: "get a toy crane machine" },
    { id: 80, src: "img/GAK-gallery/70.jpg", alt: "get a toy crane machine" },
    { id: 81, src: "img/GAK-gallery/71.jpg", alt: "get a toy crane machine" },
    { id: 82, src: "img/GAK-gallery/72.jpg", alt: "get a toy crane machine" },



    { id: 35, src: "img/GAK-gallery/56.jpg", alt: "skill tester" },
    { id: 36, src: "img/GAK-gallery/45.jpg", alt: "skill tester" },

    { id: 37, src: "img/GAK-gallery/53.jpg", alt: "skill tester" },
    { id: 38, src: "img/GAK-gallery/54.jpg", alt: "skill tester" },

    { id: 39, src: "img/GAK-gallery/55.jpg", alt: "skill tester" },
    { id: 40, src: "img/GAK-gallery/47.jpg", alt: "skill tester" },
    { id: 41, src: "img/GAK-gallery/48.jpg", alt: "skill tester" },

    { id: 42, src: "img/GAK-gallery/49.jpg", alt: "skill tester" },
    { id: 43, src: "img/GAK-gallery/50.jpg", alt: "get a toy crane machine" },
    { id: 44, src: "img/GAK-gallery/51.jpg", alt: "get a toy crane machine" },
    { id: 45, src: "img/GAK-gallery/52.jpg", alt: "get a toy crane machine" },

    { id: 46, src: "img/GAK-gallery/53.jpg", alt: "get a toy crane machine" },
    { id: 47, src: "img/GAK-gallery/41.jpg", alt: "get a toy crane machine" },
    { id: 48, src: "img/GAK-gallery/57.jpg", alt: "get a toy crane machine" },
    { id: 19, src: "img/GAK-gallery/58.jpg", alt: "get a toy crane machine" },

    { id: 49, src: "img/GAK-gallery/36.jpg", alt: "get a toy crane machine" },
    { id: 50, src: "img/GAK-gallery/37.jpg", alt: "get a toy crane machine" },
    { id: 51, src: "img/GAK-gallery/38.jpg", alt: "get a toy crane machine" },
    { id: 52, src: "img/GAK-gallery/40.jpg", alt: "get a toy crane machine" },

    // { id: 19, src: "img/GAK-gallery/41.jpg", alt: "" },
    { id: 53, src: "img/GAK-gallery/42.jpg", alt: "get a toy claw machine" },
    { id: 54, src: "img/GAK-gallery/43.jpg", alt: "get a toy claw machine" },
    { id: 55, src: "img/GAK-gallery/39.jpg", alt: "get a toy claw machine" },
    { id: 56, src: "img/GAK-gallery/46.jpg", alt: "get a toy claw machine" },

    { id: 57, src: "img/GAK-gallery/47.jpg", alt: "get a toy claw machine" },
    { id: 58, src: "img/GAK-gallery/48.jpg", alt: "get a toy claw machine" },

    { id: 59, src: "img/GAK-gallery/49.jpg", alt: "get a toy claw machine" },
    { id: 60, src: "img/GAK-gallery/50.jpg", alt: "get a toy claw machine" },
    { id: 61, src: "img/GAK-gallery/51.jpg", alt: "get a toy claw machine" },
    { id: 62, src: "img/GAK-gallery/52.jpg", alt: "get a toy claw machine" },

    { id: 63, src: "img/GAK-gallery/53.jpg", alt: "get a toy claw machine" },
    { id: 64, src: "img/GAK-gallery/54.jpg", alt: "get a toy claw machine" },
    { id: 65, src: "img/GAK-gallery/55.jpg", alt: "get a toy claw machine" },
    { id: 66, src: "img/GAK-gallery/41.jpg", alt: "get a toy claw machine" },
    { id: 67, src: "img/GAK-gallery/57.jpg", alt: "get a toy crane machine" },
    { id: 68, src: "img/GAK-gallery/58.jpg", alt: "get a toy crane machine" },

   




    // { id: 1, src: "img/GAK-gallery/01.jpg", alt: "" },
    // { id: 2, src: "img/GAK-gallery/02.jpg", alt: "" },
    { id: 3, src: "img/GAK-gallery/03.jpg", alt: "get a toy claw" },
    { id: 4, src: "img/GAK-gallery/04.jpg", alt: "get a toy claw" },
    // { id: 5, src: "img/GAK-gallery/05.jpg", alt: "" }, no va mas
    { id: 6, src: "img/GAK-gallery/33.jpg", alt: "get a toy claw" },
    { id: 7, src: "img/GAK-gallery/06.jpg", alt: "get a toy claw" },
    { id: 34, src: "img/GAK-gallery/07.jpg", alt: "get a toy claw" },
    { id: 8, src: "img/GAK-gallery/08.jpg", alt: "get a toy claw" },
    { id: 9, src: "img/GAK-gallery/09.jpg", alt: "get a toy claw" },
    { id: 10, src: "img/GAK-gallery/10.jpg", alt: "get a toy claw" },
    { id: 11, src: "img/GAK-gallery/11.jpg", alt: "get a toy claw" },
    { id: 12, src: "img/GAK-gallery/12.jpg", alt: "skill tester" },
    { id: 13, src: "img/GAK-gallery/13.jpg", alt: "skill tester" },
    { id: 14, src: "img/GAK-gallery/14.jpg", alt: "skill tester" },
    { id: 15, src: "img/GAK-gallery/15.jpg", alt: "skill tester" },
    { id: 16, src: "img/GAK-gallery/16.jpg", alt: "skill tester" },
    { id: 17, src: "img/GAK-gallery/17.jpg", alt: "skill tester" },
    { id: 18, src: "img/GAK-gallery/18.jpg", alt: "skill tester" },
    { id: 19, src: "img/GAK-gallery/19.jpg", alt: "skill tester" },
    { id: 20, src: "img/GAK-gallery/20.jpg", alt: "skill tester" },
    { id: 21, src: "img/GAK-gallery/21.jpg", alt: "skill tester" },
    { id: 22, src: "img/GAK-gallery/22.jpg", alt: "skill tester" },
    { id: 23, src: "img/GAK-gallery/23.jpg", alt: "get a toy crane" },
    { id: 24, src: "img/GAK-gallery/24.jpg", alt: "get a toy crane" },
    { id: 25, src: "img/GAK-gallery/25.jpg", alt: "get a toy crane" },
    { id: 26, src: "img/GAK-gallery/26.jpg", alt: "get a toy crane" },
    { id: 27, src: "img/GAK-gallery/27.jpg", alt: "get a toy crane" },
    { id: 28, src: "img/GAK-gallery/28.jpg", alt: "get a toy crane" },
    { id: 29, src: "img/GAK-gallery/29.jpg", alt: "get a toy crane" },
    { id: 30, src: "img/GAK-gallery/30.jpg", alt: "get a toy crane" },
    { id: 31, src: "img/GAK-gallery/31.jpg", alt: "get a toy crane" },
    { id: 32, src: "img/GAK-gallery/32.jpg", alt: "get a toy crane" },
   
    { id: 33, src: "img/GAK-gallery/34.jpg", alt: "get a toy crane" },



  ];


  return (
    <section className="gallery-section" id="Gallery">
      <div className='margin-title'>
      <div className='GAK-gallery-title'>PHOTO GALLERY</div>
      </div>
      <div className="GalleryHire">
        {lowResImages.slice(0, imagesToShow).map((image, index) => (
          <div className="responsive" key={image.id || index}>
            <div className="gallery">
              <a onClick={() => handleOpenModal(index)}>
                <img
                  src={image.src}
                  alt={image.alt}
                  width="800px"
                  height="600px"
                />
              </a>
            </div>
          </div>
        ))}
        <div className="button-position">
        {imagesToShow < lowResImages.length && !showLess && (
          <button className="SeeMoreGallery" onClick={handleLoadMore}>
            Show More
          </button>
        )}
        {showLess && (
          <button className="SeeMoreGallery" onClick={handleShowLess}>
            Show Less
          </button>
        )}
        </div>
    {/* </div> */}

<Modal
  show={modalShow}
  onHide={handleCloseModal}
  size="xl"
  centered
  dialogClassName="custom-gallery-modal"
>
  <Modal.Header closeButton>
    <Modal.Title>{lowResImages[selectedImageIndex].alt}</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Carousel
      activeIndex={selectedImageIndex}
      onSelect={(index) => setSelectedImageIndex(index)} 
    >
      {lowResImages.map((lowResImages, index) => (
        <Carousel.Item key={lowResImages.id}>
          <img
            className="d-block w-100"
            src={lowResImages.src}
            alt={lowResImages.alt}
            style={{
              cursor: "pointer",
              width: "100%",
              maxHeight: "90vh",
              objectFit: "contain",
              margin: "auto",
              display: "block",
            }}
          />
        </Carousel.Item>
      ))}
    </Carousel>
  </Modal.Body>
  <Modal.Footer>
    <button className="SeeMore" onClick={handleCloseModal}>Close</button>
  </Modal.Footer>
</Modal>


    </div>
    </section>
  );
}

export default GAKGallery;







